/*
 * @Author: shannyHuang
 * @Date: 2022-03-24 11:02:21
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-10-20 15:00:32
 * @FilePath: /wemeet-web-activity/src/utils/parse-date.ts
 */
export function getBetweenDate(t1: any, t2: any, onlyTime = false) {
  const [start, end] = [t1, t2].map((x) => parseInt(x, 10));

  if (!start || !end || start < 0 || end < 0) {
    return '';
  }
  const startYear = new Date(start * 1000).getFullYear();
  const endYear = new Date(end * 1000).getFullYear();
  const thisYear = new Date().getFullYear();
  let startDate = '';
  let endDate = '';
  if (startYear !== thisYear) {
    startDate = formatDate(start, '/');
  } else {
    startDate = formatDate(start);
    startDate = startDate.replace(`${startYear}年`, '');
  }
  if (endYear !== thisYear) {
    endDate = formatDate(end, '/');
  } else {
    endDate = formatDate(end);
    endDate = endDate.replace(`${endYear}年`, '');
  }
  // 开始和结束日期相同
  if (startDate === endDate) {
    if (onlyTime) {
      return `${formatTime(start)}-${formatTime(end)}`;
    }
    return `${startDate} ${formatTime(start)}-${formatTime(end)}`;
  }
  // 开始和结束年份不相同
  if (startYear !== endYear) {
    return `${startDate} ${formatTime(start)}-${endDate} ${formatTime(end)}`;
  }
  // 开始和结束年相同，月、日不相同
  return `${startDate} ${formatTime(start)}-${endDate} ${formatTime(end)}`;
}

export const formatDate = (timeStamp: number, separtor?: string) => {
  const date = new Date(timeStamp * 1000);
  const Y = date.getFullYear();
  const M = addPrefix(date.getMonth() + 1);
  const D = addPrefix(date.getDate());

  if (separtor) {
    return `${Y}${separtor}${M}${separtor}${D}`;
  }
  return `${Y}年${M}月${D}日`;
};

export const formatTime = (timeStamp: number) => {
  const date = new Date(timeStamp * 1000);
  const h = addPrefix(date.getHours());
  const m = addPrefix(date.getMinutes());

  return `${h}:${m}`;
};

export function addPrefix(num: number) {
  if (num >= 0 && num < 10) {
    return `0${num}`;
  }
  return num;
}

export function calcTime(start: number, end: number) {
  const startDate = new Date(start * 1000);
  const endDate = new Date(end * 1000);
  const ONE_SEC = 1e3;
  const ONE_MIN = 60 * ONE_SEC;
  const ONE_HOUR = ONE_MIN * 60;
  const ONE_DAY = 24 * ONE_HOUR;
  const dur = endDate.getTime() - startDate.getTime();
  if (dur > ONE_DAY) {
    return `${Math.floor(dur / ONE_DAY)}天`;
  }
  if (dur > ONE_HOUR) {
    return `${Math.floor(dur / ONE_HOUR)}小时`;
  }
  if (dur > ONE_MIN) {
    return `${Math.floor(dur / ONE_MIN)}分钟`;
  }
  if (dur > ONE_SEC) {
    return `${Math.floor(dur / ONE_SEC)}秒`;
  }
  return '';
}
export const getBettweenAllDate = (start: number, end: number) => {
  if (!start || !end || start < 0 || end < 0) {
    return '';
  }
  const startDate = formatAllDate(start);
  const endDate = formatAllDate(end);
  const startTime = formatTime(start);
  const endTime = formatTime(end);
  if (startDate === endDate) return `${startDate} ${startTime}-${endTime}`;
  return `${startDate} ${startTime} - ${endDate} ${endTime}`;
};
export const formatAllDate = (timeStamp: number) => {
  const date = new Date(timeStamp * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${[year, month, day].map(addPrefix).join('/')}`;
};

export const getBetweenDateForSepartor = (
  start: number,
  end: number,
  showEndDay: boolean,
  separtor = '.',
) => {
  if (!start || !end || start < 0 || end < 0) {
    return '';
  }
  const startYear = new Date(start * 1000).getFullYear();
  const endYear = new Date(end * 1000).getFullYear();
  let startDate = '';
  let endDate = '';
  startDate = formatDate(start, separtor);
  endDate = formatDate(end, separtor);
  // 开始和结束日期相同
  if (startDate === endDate && !showEndDay) {
    return `${startDate} ${formatTime(start)}-${formatTime(end)}`;
  }
  // 开始和结束年份不相同
  if (startYear !== endYear || showEndDay) {
    return `${startDate} ${formatTime(start)}-${endDate} ${formatTime(end)}`;
  }
  endDate = endDate.replace(`${endYear}${separtor}`, '');
  // 开始和结束年相同，月、日不相同
  return `${startDate} ${formatTime(start)}-${endDate} ${formatTime(end)}`;
};
